<div class="container fadeIn">
  <div class="row">
    <div class="col-12">
      <h2
        class="titleTextFont font-weight-normal text-center"
        style="font-size: 2.4rem"
        [ngStyle]="{ color: titlesColor }"
      >{{ title }}</h2>
    </div>
    <div class="col-12">
      <h2
        class="font-weight-normal fadeIn text-center mb-3 subtitle-block"
        style="font-size: 1.5rem"
        [ngStyle]="{ color: secondaryColor }"
      >{{ subtitle }}</h2>
    </div>
  </div>
  <div class="row">
    <div
      class="courseItem col-md-4 col-12 pointer"
      *ngFor="let program of programList"
      [routerLink]="['/programs/profile', program.id]"
    >
      <div class="itemImage hover-shadow">
        <picture>
          <img
            [src]="program.image"
            decoding="async"
            loading="lazy"
            alt=""
          />
        </picture>
      </div>
      <div class="itemDetails">
        <p
          class="itemTitle hover-text-shadow textFont"
          [ngStyle]="{ color: linkColor }"
        >{{ program.name }}</p>
        <div class="row justify-content-between" *ngIf="program.price">
          <div class="col-auto">
            <p class="text-info font-weight-bold">
              {{ program.price }}
              <span class="vertical-separator" *ngIf="program.priceGlobal"></span>
              <span class="text-price mr-2" *ngIf="program.priceGlobal">{{ program.priceGlobal }}</span>
            </p>
          </div>
        </div>
        <div class="row justify-content-between" *ngIf="program.included">
          <div class="col-auto">
            <p
              class="text-info font-weight-bold textFont"
              title="Este curso está incluido en tu plan"
            >Incluido</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-10 offset-md-1 text-center">
    <button
      class="btn btn-info mt-0 mb-5"
      tabindex="0"
      [routerLink]="['/block', 1]"
    >{{ buttonText }}</button>
  </div>
</div>
